var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.label,"items":_vm.items,"multiple":"","dense":_vm.dense,"hide-details":_vm.hideDetails,"outlined":_vm.outlined,"item-text":"name","item-value":_vm.itemValue},on:{"change":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53169bf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/ServiceTypeMultiSelect.vue
// module id = null
// module chunks = 